import type { SelectOptions } from '@/types/Components/SelectOptions'
import type { City } from '@/types/Models/Customer'
import type { ComputedRef } from 'vue'
import { computed } from 'vue'
import allCities from '@/assets/files/cities.json'

export const useCities = (): ComputedRef<SelectOptions[]> => {
  return computed(() => {
    const result: City[] = [
      {
        value: '',
        text: 'Choose city *',
      },
    ]
    return result.concat(
      allCities.map((cityName: string) => ({
        value: cityName,
        text: cityName,
      })),
    )
  })
}
